<template>
  <div id="app">
    <v-app> <!-- Umfasst die gesamte App -->
      <v-main class="bg-blue-grey-lighten-4">
      <v-container fluid class="d-flex justify-center bg-blue-grey-lighten-2">
          <v-row>
              <v-col cols="3"></v-col>
              <v-col cols="6">
                  <p class="font-weight-black d-flex justify-center text-h5  ">
                      BeamerAI - Layout-Vorschläge 
                  </p>
              </v-col>
              <v-col cols="3" >
              </v-col>
          </v-row>
      </v-container>
      <v-divider :thickness="2"></v-divider>

        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>


<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  components: {
  },
  data() {
    return {

    }
  },
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

@media (max-width: 600px) {
  .overview, .admin{
    display: none;
  }

}

</style>
